import { t } from "i18next";
import { useContext } from "react";
import { ColorContext } from "../../App";
import information from "../../images/information.svg";

function Colors(props) {
  const { setCurrentColor } = props;
  const { currentColor } = useContext(ColorContext);

  function displayColorInfo() {
    const infoMessage = document.getElementById('color-info-message');

    if (infoMessage.classList.contains('hidden')) { infoMessage.classList.remove('hidden'); }
    else { infoMessage.classList.add('hidden'); }
  }

  return (
    <>
      <div className="panel-section">
        <div className="section-header--color section-header section">
          {t('recommended_colors')}
          <div className="info">
            <div id="color-info-message" className="info__message hidden">
              <div className="info__message-text">{t('information_colors')}</div>
              <span className="info__message-arrow"></span>
            </div>
            <img
              onMouseEnter={displayColorInfo.bind(this)}
              onMouseLeave={displayColorInfo.bind(this)}
              className="clickable"
              src={information}
              alt="Information sign for accessing informations about recommended colors.">
            </img>
          </div>
        </div>
        <div className="line"></div>
        <div className="color-picker">
          <div
            id="white"
            onClick={() => setCurrentColor("#f9f9f9")}
            style={{ color: "#161616", backgroundColor: "#F9F9F9" }}
            className={'colors color-box ' + (currentColor === '#f9f9f9' ? 'active' : '')}
          >
            001
          </div>
          <div
            id="black"
            onClick={() => { setCurrentColor('#161616') }}
            style={{ color: "#F9F9F9", backgroundColor: "#161616" }}
            className={'colors color-box ' + (currentColor === '#161616' ? 'active' : '')}
          >
            66F
          </div>
        </div>
      </div>
    </>
  );
}

export default Colors;
